<template>
  <component :is="comp"></component>
</template>

<script>
import Detail from "./Detail";
import ListOrganisasi from "./List";
export default {
  components: {
    Detail,
    ListOrganisasi
  },
  data() {
    return {};
  },
  mounted() {},
  computed: {
    comp() {
      if (!this.current_organisasi) return "div";

      switch (this.current_organisasi.user.role) {
        case this.$consts.ROLE_SUPER_ADMIN.name:
        case this.$consts.ROLE_ADMIN.name:
          return Detail;
        case this.$consts.ROLE_OPERATOR.name:
          return Detail;
        case this.$consts.ROLE_USER.name:
          return Detail;
        default:
          return "div";
      }
    }
  },
  methods: {}
};
</script>
